import { useState } from "react";
import SettingsPageHeader from "@/components/molecules/SettingsPageHeader";

const Policies = () => {
  const [activityTab] = useState<"terms" | "policy" >(
    "terms"
  );
  return (
    <div>
      <SettingsPageHeader title="App Policies" />
      <div>
        <div className="flex gap-6 mb-6 border-b border-dark-30">
          {["Terms of Service", "Privacy Policy"].map((tab) => (
            <button
              key={tab}
              className={`pb-2 text-sm ${
                tab.toLowerCase().replace(" ", "") === activityTab ||
                (tab === "Terms of Service" && activityTab === "terms")
                  ? "text-dark-text border-b-2 border-dark-text font-medium"
                  : "text-dark-80"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        <div>
          <textarea name="" id="" rows={20} className=" w-full border-2 border-dark-text outline-0">

          </textarea>
        </div>
      </div>
    </div>
  );
};

export default Policies;
